// src/index.ts
import '@fontsource-variable/lexend'
import '@fontsource/ibm-plex-mono'
import '@fontsource/archivo-black'

import '../node_modules/normalize.css/normalize.css'

// Import styles
import './styles/parameters.css'
import './styles/animations.css'

// Import components
import './components/chat-container'
import './components/app-shell/AppShell'

import './components/layout/Box'
import './components/layout/Cluster'
import './components/layout/Stack'

import './components/ui/Button'
import './components/ui/IconButton'
import './components/ui/Text'
import './components/ui/Input'
import './components/ui/Select'

import './components/settings'

function hideUrlBar() {
    // Try to hide the URL bar
    if (typeof window.scrollTo === 'function') {
        // Delay needed for iOS
        setTimeout(() => {
            window.scrollTo(0, 1)
        }, 100)

        // Try again after a longer delay - helps on some devices
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 500)
    }
}

// Initialize application
window.addEventListener('DOMContentLoaded', () => {
    // Hide URL bar on mobile
    hideUrlBar()

    // Also try on resize events
    window.addEventListener('resize', hideUrlBar)

    // Orientation change often requires URL bar rehiding
    window.addEventListener('orientationchange', () => {
        setTimeout(hideUrlBar, 100)
    })

    // Fade in the body
    document.body.style.opacity = '1'
})
